import { render, staticRenderFns } from "./titleIndex.vue?vue&type=template&id=22a2d294&scoped=true&"
import script from "./titleIndex.vue?vue&type=script&lang=ts&"
export * from "./titleIndex.vue?vue&type=script&lang=ts&"
import style0 from "./titleIndex.vue?vue&type=style&index=0&id=22a2d294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a2d294",
  null
  
)

export default component.exports